import React from 'react';
import { Scissors, Ruler } from 'lucide-react';

/**
 * Секция формы с параметрами проемов (окна, двери)
 */
const OpeningsParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="mb-6">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Scissors className="w-5 h-5 mr-2 text-rose-500" />
        Проемы (окна и двери)
      </h3>
      
      {/* Окна */}
      <div className="mb-5 bg-gray-50 dark:bg-gray-800/50 rounded-lg p-4 border border-gray-200 dark:border-gray-700">
        <div className="flex items-center justify-between mb-3">
          <h4 className="text-sm font-medium text-gray-800 dark:text-gray-200">Окна</h4>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="includeWindows"
              checked={formData.includeWindows}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Учитывать окна
            </span>
          </label>
        </div>
        
        {formData.includeWindows && (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {/* Количество окон */}
            <div>
              <label htmlFor="windowsCount" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Количество окон
              </label>
              <input
                type="text"
                id="windowsCount"
                name="windowsCount"
                value={formData.windowsCount}
                onChange={handleInputChange}
                className={`form-input w-full ${errors.windowsCount ? 'input-error' : ''}`}
                placeholder="Количество"
              />
              {errors.windowsCount && (
                <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                  {errors.windowsCount}
                </p>
              )}
            </div>

            {/* Ширина окна */}
            <div>
              <label htmlFor="windowWidth" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
                <Ruler className="w-4 h-4 mr-2 text-gray-500" />
                Ширина окна (м)
              </label>
              <input
                type="text"
                id="windowWidth"
                name="windowWidth"
                value={formData.windowWidth}
                onChange={handleInputChange}
                className={`form-input w-full ${errors.windowWidth ? 'input-error' : ''}`}
                placeholder="Ширина"
              />
              {errors.windowWidth && (
                <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                  {errors.windowWidth}
                </p>
              )}
            </div>

            {/* Высота окна */}
            <div>
              <label htmlFor="windowHeight" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
                <Ruler className="w-4 h-4 mr-2 text-gray-500" />
                Высота окна (м)
              </label>
              <input
                type="text"
                id="windowHeight"
                name="windowHeight"
                value={formData.windowHeight}
                onChange={handleInputChange}
                className={`form-input w-full ${errors.windowHeight ? 'input-error' : ''}`}
                placeholder="Высота"
              />
              {errors.windowHeight && (
                <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                  {errors.windowHeight}
                </p>
              )}
            </div>
          </div>
        )}
      </div>
      
      {/* Двери */}
      <div className="bg-gray-50 dark:bg-gray-800/50 rounded-lg p-4 border border-gray-200 dark:border-gray-700">
        <div className="flex items-center justify-between mb-3">
          <h4 className="text-sm font-medium text-gray-800 dark:text-gray-200">Двери</h4>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="includeDoors"
              checked={formData.includeDoors}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Учитывать двери
            </span>
          </label>
        </div>
        
        {formData.includeDoors && (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {/* Количество дверей */}
            <div>
              <label htmlFor="doorsCount" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Количество дверей
              </label>
              <input
                type="text"
                id="doorsCount"
                name="doorsCount"
                value={formData.doorsCount}
                onChange={handleInputChange}
                className={`form-input w-full ${errors.doorsCount ? 'input-error' : ''}`}
                placeholder="Количество"
              />
              {errors.doorsCount && (
                <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                  {errors.doorsCount}
                </p>
              )}
            </div>

            {/* Ширина двери */}
            <div>
              <label htmlFor="doorWidth" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
                <Ruler className="w-4 h-4 mr-2 text-gray-500" />
                Ширина двери (м)
              </label>
              <input
                type="text"
                id="doorWidth"
                name="doorWidth"
                value={formData.doorWidth}
                onChange={handleInputChange}
                className={`form-input w-full ${errors.doorWidth ? 'input-error' : ''}`}
                placeholder="Ширина"
              />
              {errors.doorWidth && (
                <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                  {errors.doorWidth}
                </p>
              )}
            </div>

            {/* Высота двери */}
            <div>
              <label htmlFor="doorHeight" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
                <Ruler className="w-4 h-4 mr-2 text-gray-500" />
                Высота двери (м)
              </label>
              <input
                type="text"
                id="doorHeight"
                name="doorHeight"
                value={formData.doorHeight}
                onChange={handleInputChange}
                className={`form-input w-full ${errors.doorHeight ? 'input-error' : ''}`}
                placeholder="Высота"
              />
              {errors.doorHeight && (
                <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                  {errors.doorHeight}
                </p>
              )}
            </div>
          </div>
        )}
      </div>
      
      {/* Подсказка */}
      <div className="mt-3 text-sm text-gray-600 dark:text-gray-400 italic">
        <p>Указанная площадь окон и дверей будет вычтена из общей площади стен при расчете количества обоев.</p>
      </div>
    </div>
  );
};

export default OpeningsParametersSection;